import { Component, effect, inject, input, OnInit, Signal } from '@angular/core';
import { ChangedOpeningHoursNotification, OpeningPeriods, SpecialDayOpeningHours } from '../../../../state-management/model/interfaces/state.model';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle, MatDialogModule, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { WebsiteStateService } from '../../../../state-management/services/website-state.service';

@Component({
  selector: 'app-special-opening-hours-dialog',
  // standalone: true,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions
  ],
  templateUrl: './special-opening-hours-dialog.component.html',
  styleUrl: './special-opening-hours-dialog.component.scss'
})
export class SpecialOpeningHoursDialogComponent{

  // constructor() { }
  data: { notificationText: string, dates: {date: string, periods: OpeningPeriods[]}[]} = inject(MAT_DIALOG_DATA);
  readonly dialogRef = inject(MatDialogRef<SpecialOpeningHoursDialogComponent>);
  // readonly dates =  input.required<{date: string, periods: OpeningPeriods[]}[]>();
  // readonly notificationText =  input.required<string>();

  close() {
    this.dialogRef.close();
  }
}
